import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthorizeGuard} from './infrastructure/guards/authorize.guard';

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () => import("./features/login-container/login-container.module").then(m => m.LoginContainerModule)
  },
  {
    path: '',
    loadChildren: () => import("./features/app-container/app-container.module").then(m => m.AppContainerModule),
    canActivate: [AuthorizeGuard]
  },
  {
    path: 'not-found',
    loadChildren: () => import("./features/not-found/not-found.module").then(m => m.NotFoundModule),
    canActivate: [AuthorizeGuard]
  },
  {
    path: "**",
    pathMatch: 'full',
    redirectTo: 'not-found',
  }
]

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
